<div
  class="dialog-shell"
  cdkDrag
  [cdkDragRootElement]="'#' + dialogRef.id"
  cdkDragBoundary=".cdk-overlay-container"
  mwlResizable
  [enableGhostResize]="false"
  ghostElementPositioning="fixed"
  [validateResize]="validateResize"
  (resizeStart)="onResizeStart($event)"
  (resizing)="onResizing($event)"
  (resizeEnd)="onResizeEnd($event)"
>
  <div class="invisible-handle" cdkDragHandle></div>

  <div class="dialog-content">
    <ng-container #contentHost></ng-container>
  </div>

  @if (resizable) {
    <div class="resize-handle resize-handle--right" mwlResizeHandle [resizeEdges]="{ right: true }">
      <span></span>
    </div>
    <div
      class="resize-handle resize-handle--bottom"
      mwlResizeHandle
      [resizeEdges]="{ bottom: true }"
    >
      <span></span>
    </div>
    <div
      class="resize-handle resize-handle--bottom-right"
      mwlResizeHandle
      [resizeEdges]="{ right: true, bottom: true }"
      matTooltip="Drag to resize"
      [matTooltipPosition]="'above'"
    >
      <svg width="16" height="16" viewBox="0 0 10 10" focusable="false" aria-hidden="true">
        <path d="M9 1v1H8V1h1zM9 3v1H8V3h1zM9 5v1H8V5h1zM7 3v1H6V3h1zM7 5v1H6V5h1zM5 5v1H4V5h1z" />
      </svg>
    </div>
  }
</div>
